export default __webpack_public_path__ + "media/images/65-7386e57ad69b07be7cb2c33743bb878f.jpg";